
import { Component, Mixins, Prop } from "vue-property-decorator";
import { VuetifyMixin, AthleteRoutingMixin, AuthMixin, BAIconsMixin, CoachReportScoreMixin } from "@/mixins";
import ViewScoutingReport from '../views/ViewScoutingReport.vue';

@Component({
	components: {ViewScoutingReport },
})

export default class AthleteScoutingReport extends Mixins(AuthMixin, VuetifyMixin, CoachReportScoreMixin, AthleteRoutingMixin, BAIconsMixin){
	@Prop({ default: null, type: String }) reportId: string | null;

}

